module.exports = __webpack_public_path__ + "img/htd.7a8bbc83.jpg";